import { Box } from '@mui/material';
import { Viewer } from '@/components/Analysis/Viewer';
import { FluidLayout } from '@/layouts';
import { StructureCheck } from '@/components/shared/StructureCheck';
import { useDefaultAnalysisKeyboardShortcuts, useFetchCookies, useRouter } from '@/hooks';
import { PageLoader } from '@/components/shared/PageLoader';
import { AccessGuard } from '@/components/Analysis/shared/AccessGuard';

export const AnalysisViewerPage = () => {
  const router = useRouter();
  const { inspection } = router.query;
  const cookiesFetched = useFetchCookies();

  useDefaultAnalysisKeyboardShortcuts();

  if (!inspection || Array.isArray(inspection)) {
    return <div>Please specify inspection id</div>;
  }

  if (!cookiesFetched) {
    return (
      <Box sx={{ position: 'relative', top: '25rem' }}>
        <PageLoader />
      </Box>
    );
  }

  return (
    <StructureCheck structureId={inspection}>
      <AccessGuard structureId={inspection} feature="viewer">
        <FluidLayout variant="analysis">
          <Viewer inspectionId={inspection} />
        </FluidLayout>
      </AccessGuard>
    </StructureCheck>
  );
};

